<template>
	<div>
		<div class="row mb-2">
			<div class="col-10 my-auto">
				<p class="font-weight-bold">Commercial Configuration</p>
			</div>
			<div class="col-2 d-inline my-auto">
				<i
					class="float-right pointer pr-2 fas fa-edit fas-lg"
					v-show="!disableEdit"
					v-if="!editConfigMode"
					@click="toggleEditMode"></i>
			</div>
		</div>
		<b-card
			no-body
			class="container-flex border-0">
			<div class="row text-left">
				<div class="col-sm-6">
					<div class="row">
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">Effective From</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-12">
									<p class="pl-2">
										{{
											activeCommercialConfig.EffectiveFrom
												| moment('DD MMMM YYYY')
										}}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="col-sm-6"
					v-if="activeCommercialConfig.hasOwnProperty('EffectiveTo')">
					<div class="col-12">
						<p class="font-weight-bold text-left pl-2">Effective To</p>
					</div>
					<div class="col-12">
						<p>
							{{ activeCommercialConfig.EffectiveTo | moment('DD MMMM YYYY') }}
						</p>
					</div>
				</div>
			</div>
			<hr class="mt-4" />
			<div class="row text-left">
				<div class="col-sm-6">
					<div class="row">
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">Commercial %</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-9">
									<input
										type="range"
										class="w-100 slider"
										min="0"
										max="100"
										step="1"
										v-model="activeCommercialConfig.CommercialPercentage"
										:disabled="true"
										v-if="!editConfigMode" />
									<input
										type="range"
										class="w-100 slider"
										min="0"
										max="100"
										step="1"
										v-model="configCopy.CommercialPercentage"
										v-else />
								</div>
								<div class="col-3">
									<input
										type="number"
										class="w-100 border border-secondary brs text-center"
										v-model="configCopy.CommercialPercentage"
										v-if="editConfigMode" />
									<p v-else>
										{{ activeCommercialConfig.CommercialPercentage }}%
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="col-12">
						<p class="font-weight-bold text-left pl-2">CCL Exemption Type</p>
					</div>
					<div class="col-12">
						<div class="btn-group d-block w-100">
							<div class="form-group my-auto">
								<b-form-select
									v-model="configCopy.CclExemptionType"
									class="form-control"
									name="selection"
									required
									v-if="editConfigMode">
									<option value="NotExempt">Not Exempt</option>
									<option value="Charity">Charity</option>
									<option value="Domestic">Domestic</option>
									<option value="Usage">Usage</option>
									<option value="ClimateChangeAgreementInPlace">
										Climate change agreement in place
									</option>
								</b-form-select>
								<p
									class="pl-2"
									v-else-if="activeCommercialConfig.CclExemptionType">
									{{ activeCommercialConfig.CclExemptionType | splitString }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr class="mt-4" />
			<div class="row text-left">
				<div class="col-sm-6">
					<div class="row">
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">CCA Reduction %</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-9">
									<input
										type="range"
										class="w-100 slider"
										min="0"
										max="100"
										step="1"
										v-model="activeCommercialConfig.CcaReductionPercentage"
										:disabled="true"
										v-if="!editConfigMode" />
									<input
										type="range"
										class="w-100 slider"
										min="0"
										max="100"
										step="1"
										v-model="configCopy.CcaReductionPercentage"
										v-else />
								</div>
								<div class="col-3">
									<input
										type="number"
										class="w-100 border border-secondary brs text-center"
										v-model="configCopy.CcaReductionPercentage"
										v-if="editConfigMode" />
									<p v-else>
										{{ activeCommercialConfig.CcaReductionPercentage }}%
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="col-12">
						<p class="font-weight-bold text-left pl-2">
							CCA Agreement Description
						</p>
					</div>
					<div class="col-12">
						<textarea
							v-model="configCopy.CcaAgreementDescription"
							class="form-control z-depth-1"
							id="exampleFormControlTextarea5"
							rows="3"
							placeholder="Make your notes here..."
							v-if="editConfigMode"></textarea>
						<p
							class="pl-2"
							v-else>
							{{ activeCommercialConfig.CcaAgreementDescription }}
						</p>
					</div>
				</div>
			</div>

			<div
				class="row text-left mb-4"
				v-if="isHH">
				<div class="col-sm-6">
					<p class="font-weight-bold text-left pl-2">HH NHH Mapping</p>
					<div class="btn-group d-block w-100">
						<div class="form-group my-auto">
							<b-form-select
								v-if="editConfigMode"
								v-model="configCopy.HhNhhMappingId"
								class="form-control"
							name="selection">
								<option :value="null">Not Applicable</option>
								<option
									v-for="mapping in HHNHHMappings"
									:key="mapping.value"
									:value="mapping.value">
									{{ mapping.label }}
								</option>
							</b-form-select>
							<p
								class="pl-2"
								v-else>
								{{
									mappedmap(activeCommercialConfig.HhNhhMappingId) ||
									'Not Applicable'
								}}
							</p>
						</div>
					</div>
				</div>
			</div>

			<div class="row text-left align-items-center mb-5" v-if="activeServiceType !== 'Electricity' || !isHH">
				<div
					v-show="editConfigMode"
					class="col-sm-6">
					<label class="checkbox">
						<input
							type="checkbox"
							:disabled="!editConfigMode"
							v-model="overrideIndustry" />
						<span class="default"></span>
					</label>
					<span v-if="activeServiceType === 'Electricity'" class="d-inline pl-2">Override Industry Eac?</span>
					<span v-if="activeServiceType === 'Gas'" class="d-inline pl-2">Override Industry AQ?</span>
				</div>
			</div>
			<div
				v-if="activeService.ServiceType === 'Electricity' && !isHH"
				class="row text-left">
				<div
					class="col-sm-4"
					v-if="!editConfigMode || (editConfigMode && overrideIndustry)">
					<div class="row">
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">
								Meter Point Billing EAC
							</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div class="d-block w-100">
								<input
									type="number"
									class="w-100 sh border border-secondary brs text-center"
									v-model="configCopy.MeterPointBillingEac"
									v-if="
										editConfigMode &&
										configCopy.EacLevel === 'MeterPoint' &&
										overrideIndustry
									"
									@change="updateBillingEacs(configCopy)" />
								<input
									v-else-if="
										editConfigMode && configCopy.EacLevel === 'Register'
									"
									disabled
									:placeholder="getMeterPointBillingEac(configCopy)"
									type="number"
									class="w-100 sh border border-secondary brs text-center"
									@change="updateBillingEacs(billingEac)" />
								<p
									v-else-if="!isNaN(activeCommercialConfig.MeterPointBillingEac)"
									class="pl-2">
									{{ activeCommercialConfig.MeterPointBillingEac }}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div
					class="col-sm-8"
					v-if="!editConfigMode || (editConfigMode && overrideIndustry)">
					<div class="row">
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">EAC Level</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<b-form-select
								v-model="configCopy.EacLevel"
								class="form-control"
								name="selection"
								required
								v-if="editConfigMode">
								<option value="MeterPoint">Meter Point</option>
								<option value="Register">Register</option>
							</b-form-select>
							<p
								v-else
								class="pl-2">
								{{ activeCommercialConfig.EacLevel | splitString }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row text-left">
				<div class="col-sm-4">
					<div class="row">
						<div class="col-12">
							<p
								v-if="activeService.ServiceType === 'Gas'  &&
									(!editConfigMode || overrideIndustry)"
								class="font-weight-bold text-left pl-2">
								Billing AQ
							</p>
							<p
								v-else-if="
									activeService.ServiceType === 'Electricity' && !isHH &&
									(!editConfigMode || overrideIndustry)
								"
								class="font-weight-bold text-left pl-2">
								Billing EAC
							</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div
								class="d-block w-100"
								v-if="activeService.ServiceType === 'Gas'  &&
									(!editConfigMode || overrideIndustry)">
								<input
									type="number"
									class="w-100 sh border border-secondary brs text-center"
									v-model="configCopy.BillingAq"
									v-if="editConfigMode" />
								<p
									v-else
									class="pl-2">
									{{ activeCommercialConfig.BillingAq }}
								</p>
							</div>
							<div
								class="d-block w-100"
								v-else-if="
									activeService.ServiceType === 'Electricity' && !isHH &&
									(!editConfigMode || overrideIndustry)
								">
								<div v-if="editConfigMode && overrideIndustry">
									<div
										v-for="(eac, index) in configCopy.BillingEac"
										:key="index"
										class="row pb-1">
										<div class="col">
											<p
												type="text"
												class="pl-2">
												{{ getBillingTypeId(eac.RegisterId) }} ({{
													eac.RegisterId
												}})
											</p>
										</div>
										<div class="col">
											<input
												type="number"
												class="w-100 sh border border-secondary brs text-center"
												:disabled="configCopy.EacLevel === 'MeterPoint'"
												v-model="eac.BillingEac" />
										</div>
									</div>
								</div>
								<div v-else>
									<div
										v-for="eac in activeCommercialConfig.BillingEac"
										:key="eac.RegisterId"
										class="row">
										<div class="col">
											<p class="pl-2">
												{{ getBillingTypeId(eac.RegisterId) }} ({{
													eac.RegisterId
												}})
											</p>
										</div>
										<div class="col">
											<p v-if="eac.BillingEac !== null" class="pl-2">{{ eac.BillingEac }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="col-sm-8"
					v-if="
						activeService.ServiceType !== 'Electricity' && (!editConfigMode || overrideIndustry) ||
						(activeService.ServiceType === 'Electricity' && !isHH &&
							(!editConfigMode || overrideIndustry))
					">
					<div class="row">
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">Use</p>
						</div>
						<div class="col-12">
							<div class="btn-group d-block w-100">
								<div class="form-group my-auto">
									<b-form-select
										v-model="configCopy.ApplicationRule"
										class="form-control"
										name="selection"
										required
										v-if="editConfigMode">
										<option value="WhenBillingIsHigherThanIndustry">
											When higher than the Industry {{ units }}
										</option>
										<option value="WhenBillingIsLowerThanIndustry">
											When lower than the Industry {{ units }}
										</option>
										<option value="Always">Always</option>
									</b-form-select>
									<p
										class="pl-2"
										v-else-if="activeCommercialConfig.ApplicationRule">
										{{ activeCommercialConfig.ApplicationRule | splitString }}
									</p>
								</div>
							</div>
						</div>
						<hr class="mt-4" />
					</div>
				</div>
			</div>
			<div v-if="editConfigMode">
				<div class="row">
					<div class="col-12">
						<div>
							<div class="text-left float-right">
								<b-btn
									@click="cancelConfigChanges"
									class="btn btn-hc mr-1"
									:disabled="submitStatus == 'PENDING'"
									>Cancel</b-btn
								>
								<b-btn
									@click="saveConfigChanges(configCopy)"
									class="btn btn-hc ml-1"
									:disabled="submitStatus == 'PENDING' || mappingInvalid">
									Save Changes
								</b-btn>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-card>
	</div>
</template>

<script>
// Mixins
// import { _ } from 'vue-underscore';
import _filters from '@/mixins/filters.js';
import contractsMixin from '@/mixins/contracts/contracts';
import commConfigMixin from '@/mixins/contracts/commercialConfigs/commercialConfigs';

export default {
	mixins: [_filters, contractsMixin, commConfigMixin],
	name: 'CommercialConfig',
	data() {
		return {
			editConfigMode: false,
			configCopy: null,
			error: null,
			overrideIndustry: null,
		};
	},
	computed: {
		disableEdit() {
			return this.activeContract.ContractStatus == 'NotChargeable';
		},
	},
	methods: {
		mappedmap(hhnhhmap) {
			let mp = this.$store.state.contracts.hhnhhmappings.find(
				(m) => m.value === hhnhhmap
			);

			if (mp) return mp.label;
		},

		toggleEditMode() {
			this.editConfigMode = !this.editConfigMode;
			if (this.editConfigMode) {
				// Creates a deep clone of object for editing
				this.configCopy = JSON.parse(
					JSON.stringify(this.activeCommercialConfig)
				);

				if (this.configCopy.HhNhhMappingId === undefined) {
					this.configCopy.HhNhhMappingId = null;
				}

        if (this.activeServiceType === 'Electricity') {
          this.overrideIndustry = this.configCopy.MeterPointBillingEac != null
        }

        if (this.activeServiceType === 'Gas') {
          this.overrideIndustry = this.configCopy.BillingAq != null;
        }

				if (
					this.activeServiceType == 'Electricity' &&
					this.configCopy.BillingEac.length == 0
				) {
					this.configCopy.BillingEac = this.createBillingEacObject();
				}
			}
		},
		cancelConfigChanges() {
			this.editConfigMode = false;
			this.configCopy = null;
		},
	},
};
</script>
